import type { MoneySummary, SpendCoverage } from "@/types/spend";

export const SpendQualityLabel = ({
  money,
  coverage,
  qualityFlags = [],
}: {
  money: MoneySummary;
  coverage?: SpendCoverage;
  qualityFlags?: string[];
}) => {
  const incompleteCoverage = qualityFlags.some(flag => flag === "partial_coverage" || flag === "unknown_coverage");
  const labels = [
    !money.has_data ? "No Available Spend" : null,
    money.missing_fx_count
      ? `${money.missing_fx_count} invoice line${money.missing_fx_count === 1 ? "" : "s"} could not be converted to GBP`
      : null,
    incompleteCoverage ? "Spend data does not cover the full selected period" : null,
    money.has_data && !money.complete && !money.missing_fx_count && !incompleteCoverage ? "Incomplete spend" : null,
    money.credit_count ? `${money.credit_count} credit${money.credit_count === 1 ? "" : "s"}` : null,
    coverage === "partial" ? "Partial period" : null,
    coverage === "unknown" ? "Coverage unknown" : null,
    coverage === "outside_contract" ? "Outside contract" : null,
  ].filter(Boolean);
  return labels.length ? <span className="text-xs font-medium text-amber-800">{labels.join(" · ")}</span> : null;
};
